import React from 'react';
// import BgImage from "../../../assets/image/Intro.png";
import BgImage from "../../../assets/image/Intro-test.png";

const PlayingNow = () => {
    return (
        <div className="mt-12 lgs:mt-0 text-yellow-400 py-8 text-center  w-full" style={{
            backgroundImage: `url(${BgImage})`,
            backgroundPosition: "bottom",
            // backgroundSize: "cover",
            
        }}>
            <h1 className="text-xl lgs:text-[27px] font-semibold mb-4">
                Faster Payouts, No Hassle! BitPlay's new withdrawal process gets your money to you in no time
            </h1>
            <button
                className="bg-yellow-400 text-gray-900 px-6 py-2 rounded-lg text-lg font-semibold hover:bg-[#ffd21e] transition-colors shadow-custom"
            >
                Start Playing Now
            </button>
        </div>
    );
};

export default PlayingNow;
